import { array } from '@ember/helper';
import { variation } from 'ember-launch-darkly';
import {
  BreadcrumbsItem,
  HcpAppFrame,
  LayoutSidebarMainNav,
} from 'core/components';
import TfcMigrationModal from 'hcp/components/tfc-migration-modal';
import HcpEuPrivateBetaModal from 'hcp/components/hcp-eu-private-beta-modal';

<template>
  {{#if @controller.userContext.organization.id}}
    <BreadcrumbsItem
      @icon="org"
      @route="cloud.orgs.detail.index"
      @models={{array @controller.userContext.organization.id}}
      @text={{@controller.userContext.organization.name}}
    />
  {{/if}}

  <HcpAppFrame @showHelpMenu={{true}} @showStatusPageLink={{true}}>
    <LayoutSidebarMainNav />

    {{#if (variation "hcp-tfc-unified-experience")}}
      <TfcMigrationModal />
    {{/if}}

    <HcpEuPrivateBetaModal />

    {{outlet}}
  </HcpAppFrame>
</template>
